(() => {
  'use strict';
  const KEY = 'BosscoLandingNativePurchase';
  if (window[KEY]) { window[KEY].scan(); return; }
  const TEMPLATE = '[data-bc-native-purchase-template]';
  const SOURCE = '[data-bc-native-purchase-source]';
  const HERO = '[data-bc-electric-landing], [data-bc-roller-landing], [data-bc-drawer-landing], [data-bc-landing]';
  const records = new Map();
  const unloading = new WeakSet();
  let timer = 0, scanning = false, retries = 0, observer;

  function bridges() {
    ['BosscoElectricLanding', 'BosscoRollerLanding', 'BosscoElectricDelivery', 'BosscoRollerDelivery', 'BosscoDrawerLanding', 'BosscoDrawerDelivery', 'BosscoCanopyLanding', 'BosscoCanopyDelivery'].forEach(key => window[key]?.scan());
  }
  function runtimeReady() {
    return window.jQuery && window.theme?.OptionManager && window.theme?.StoreAvailability &&
      window.theme?.Sections?._sections?.some(item => item.type === 'main-product');
  }
  function schedule(delay = 0) {
    if (!timer) timer = setTimeout(() => { timer = 0; scan(); }, delay);
  }
  function heroFor(template) {
    return template.closest('.shopify-section')?.querySelector(HERO) || template.closest(HERO);
  }
  function externalFor(productId) {
    return Array.from(document.querySelectorAll('[data-section-type="main-product"] .product-form')).find(form =>
      form.dataset.productId === productId && !form.closest(SOURCE) &&
      !unloading.has(form.closest('.shopify-section'))
    )?.closest('[data-section-type="main-product"]');
  }
  function titleTag(hero, tag) {
    const current = hero?.querySelector('.bc-hero-buy__product');
    if (!current || current.tagName.toLowerCase() === tag) return;
    const replacement = document.createElement(tag);
    for (const attribute of current.attributes) replacement.setAttribute(attribute.name, attribute.value);
    replacement.append(...current.childNodes);
    current.replaceWith(replacement);
  }
  function linksFor(hero, active) {
    const prefix = hero?.matches('[data-bc-landing]') ? 'bc-canopy' : hero?.matches('[data-bc-drawer-landing]') ? 'bc-drawer' : hero?.matches('[data-bc-electric-landing]') ? 'bc-electric' : 'bc-roller';
    if (!hero) return;
    if (active && !hero.id) hero.id = `${prefix}-hero`;
    document.querySelectorAll(`a[href="#${prefix}-buy"],a[data-bc-native-original-href="#${prefix}-buy"]`).forEach(link => {
      if (active && !document.getElementById(`${prefix}-buy`)) {
        if (!link.dataset.bcNativeOriginalHref) link.dataset.bcNativeOriginalHref = link.getAttribute('href');
        link.setAttribute('href', `#${hero.id}`);
      } else if (link.dataset.bcNativeOriginalHref) {
        link.setAttribute('href', link.dataset.bcNativeOriginalHref);
        delete link.dataset.bcNativeOriginalHref;
      }
    });
  }
  function lowStock(source) {
    const option = source.querySelector('.original-selector')?.selectedOptions[0];
    const notice = source.querySelector('.product-low-stock-notice');
    const count = Number(option?.dataset.inventory);
    if (!notice) return;
    const show = count > 0 && count <= 5;
    const text = show ? `Only ${count} left in stock` : '';
    if (notice.firstElementChild.textContent !== text) notice.firstElementChild.textContent = text;
    if (notice.style.display !== (show ? 'block' : 'none')) notice.style.display = show ? 'block' : 'none';
  }
  function bootRestock(record) {
    const runtime = window.__bosscoProductRestockRuntime;
    if (runtime && record.restockRuntime !== runtime) {
      record.restockRuntime = runtime;
      runtime.boot(record.source);
    }
    return !!runtime || !record.source.querySelector('[data-bossco-restock-date]');
  }
  function unload(record) {
    record.active = false;
    record.pickupGeneration++;
    record.source.removeEventListener('change', record.onChange);
    const sections = window.theme?.Sections;
    const instance = sections?._instances?.find(item => item.target === record.source);
    if (instance) {
      // Mode's sectionUnload splices from its index through the end. Preserve
      // every other live section rather than losing their runtime registrations.
      const survivors = sections._instances.filter(item => item !== instance);
      sections.sectionUnload(record.source);
      for (const survivor of survivors) {
        if (!sections._instances.includes(survivor)) sections._instances.push(survivor);
      }
    }
    record.pickup?.$modal?.remove();
    record.source.remove();
    titleTag(record.hero, record.hero.matches('[data-bc-drawer-landing]') && !externalFor(record.template.dataset.productId) ? 'h1' : 'p');
    linksFor(record.hero, false);
    records.delete(record.template);
  }
  function mount(template, hero) {
    const source = template.content.firstElementChild?.cloneNode(true);
    if (!source || !hero) return;
    const record = { template, hero, source, active: true, pickupGeneration: 0 };
    const pickup = source.querySelector('[data-store-availability-container]');
    const pickupProduct = pickup?.getAttribute('data-store-availability-container');
    const singleVariant = pickup?.getAttribute('data-single-variant-id');
    // Register the form first; attach native pickup before making its first
    // request so single-variant initialisation cannot race editor replacement.
    pickup?.removeAttribute('data-store-availability-container');
    pickup?.removeAttribute('data-single-variant-id');
    template.after(source);
    records.set(template, record);
    record.onChange = event => { if (event.target.name === 'id') lowStock(source); };
    source.addEventListener('change', record.onChange);
    try {
      window.theme.Sections.sectionLoad(source);
      const instance = window.theme.Sections._instances.find(item => item.target === source);
      if (!instance || !source.querySelector('.product-form.theme-init')) {
        throw new Error('Mode product form did not initialise');
      }
      // This source has no gallery. Mode's normal gallery unload removes a
      // shared window handler, including a newly restored product gallery.
      // Keep native form/pickup teardown scoped to this registered instance.
      instance.section = Object.assign(Object.create(instance.section), {
        onSectionUnload(container) {
          window.jQuery('.product-form', container).trigger('unload-product-form');
          this.storeAvailability?.onSectionUnload();
        }
      });
      if (pickup) {
        pickup.setAttribute('data-store-availability-container', pickupProduct);
        pickup.dataset.sectionType = 'bc-landing-pickup';
        pickup.dataset.sectionId = source.dataset.sectionId;
        const runtime = new window.theme.StoreAvailability(pickup);
        record.pickup = runtime;
        instance.thisContext.storeAvailability = runtime;
        if (singleVariant) pickup.setAttribute('data-single-variant-id', singleVariant);
        const originalUpdate = runtime.functions.updateContent;
        const originalGet = runtime.functions.getAvailableStores;
        runtime.functions.updateContent = function (...args) {
          record.pickupGeneration++;
          return originalUpdate.apply(this, args);
        };
        runtime.functions.getAvailableStores = function (variantId, callback) {
          const generation = record.pickupGeneration;
          return originalGet.call(this, variantId, (...args) => {
            if (!record.active || !source.isConnected || generation !== record.pickupGeneration ||
                String(variantId) !== source.querySelector('.original-selector')?.value) return;
            return callback(...args);
          });
        };
      }
      lowStock(source);
      titleTag(hero, 'h1');
      linksFor(hero, true);
      bridges();
      bootRestock(record);
      if (record.pickup) {
        const variant = window.theme.OptionManager.getCurrentVariantData(window.jQuery(source.querySelector('.product-form')));
        const product = window.theme.OptionManager.getProductData(window.jQuery(source.querySelector('.product-form')));
        record.pickup.functions.updateContent.call(record.pickup, variant.id, product.title, pickup.dataset.hasOnlyDefaultVariant === 'true', variant.available);
      }
      return record;
    } catch (error) {
      unload(record);
      console.error('[Bossco landing] Native purchase initialisation failed.', error);
    }
  }
  function scan() {
    if (scanning) return;
    scanning = true;
    let changed = false, waiting = false;
    try {
      for (const record of Array.from(records.values())) {
        if (!record.template.isConnected || !record.hero.isConnected ||
            unloading.has(record.template.closest('.shopify-section')) || externalFor(record.template.dataset.productId)) {
          unload(record); changed = true;
        }
      }
      const templates = Array.from(document.querySelectorAll(TEMPLATE));
      for (const template of templates) {
        if (unloading.has(template.closest('.shopify-section'))) continue;
        const hero = heroFor(template);
        if (!hero || !hero.querySelector('[data-bc-purchase]')) continue;
        const external = externalFor(template.dataset.productId);
        // Drawer heroes supply their product H1 in server-rendered HTML. Keep
        // it even while Mode is loading; only a native product section replaces it.
        if (hero.matches('[data-bc-drawer-landing]')) titleTag(hero, external ? 'p' : 'h1');
        if (external) continue;
        let record = records.get(template);
        if (!record) {
          if (document.readyState === 'loading' || !runtimeReady()) { waiting = true; continue; }
          record = mount(template, hero);
          changed = !!record || changed;
        }
        if (record && !bootRestock(record)) waiting = true;
      }
      if (changed) bridges();
      if (waiting && retries++ < 120) schedule(retries < 30 ? 100 : 1000);
      else if (!waiting) retries = 0;
    } finally { scanning = false; }
  }
  function watch() {
    if (observer || !document.body) return;
    const structural = `${TEMPLATE},[data-section-type="main-product"],${HERO}`;
    observer = new MutationObserver(mutations => {
      const relevant = mutations.some(mutation => [...mutation.addedNodes, ...mutation.removedNodes].some(node =>
        node instanceof Element && !node.matches(SOURCE) && !node.closest(SOURCE) &&
        (node.matches(structural) || node.querySelector(structural))
      ));
      if (relevant) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  window[KEY] = { scan };
  document.addEventListener('shopify:section:unload', event => {
    unloading.add(event.target);
    for (const record of Array.from(records.values())) {
      if (event.target.contains(record.template)) unload(record);
    }
    schedule();
  }, true);
  document.addEventListener('shopify:section:load', event => {
    unloading.delete(event.target); retries = 0; schedule();
  });
  document.addEventListener('shopify:section:reorder', () => schedule());
  document.addEventListener('DOMContentLoaded', () => { watch(); scan(); }, { once: true });
  window.addEventListener('load', () => { retries = 0; scan(); }, { once: true });
  // A late app asset can appear after the theme itself is ready.
  document.addEventListener('load', event => {
    if (event.target instanceof HTMLScriptElement && /product-restock-date|theme\.js/.test(event.target.src)) {
      retries = 0; schedule();
    }
  }, true);
  watch();
  scan();
})();
